var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "breadcrumbs"
  }, [_c('b-overlay', {
    staticClass: "new-breadcrumbs-overlay",
    attrs: {
      "show": _vm.isLoading,
      "aria-label": "breadcrumb"
    }
  }, [_c('b-breadcrumb', {
    staticClass: "mobile-breadcrumbs"
  }, [_vm.itemsWithIcons.length > 1 ? _c('b-breadcrumb-item', {
    key: 'dropdown',
    staticClass: "breadcrumb-item"
  }, [_c('b-dropdown', {
    attrs: {
      "text": "...",
      "variant": "link",
      "no-caret": "",
      "menu-class": "dropdown-menu-dark"
    }
  }, _vm._l(_vm.itemsWithIcons.slice(0, -1), function (item, index) {
    return _c('b-dropdown-item', {
      key: index,
      staticClass: "dark-dropdown-item",
      attrs: {
        "href": item.path
      }
    }, [_c('div', {
      staticClass: "breadcrumb-content",
      on: {
        "click": function ($event) {
          return _vm.navigateTo(item, $event);
        }
      }
    }, [item.iconClass === 'flexibility-icon' ? [_c('FlexibilityIcon', {
      staticClass: "icon breadcrumb-icon",
      staticStyle: {
        "height": "15px"
      }
    })] : [_c('span', {
      staticClass: "breadcrumb-icon",
      class: item.iconClass
    })], _c('span', {
      staticClass: "breadcrumb-title"
    }, [_vm._v(_vm._s(_vm.getTranslatedBreadcrumbText(item)))])], 2)]);
  }), 1)], 1) : _vm._e(), _vm._l(_vm.itemsWithIcons.slice(-1), function (item, index) {
    return _c('b-breadcrumb-item', {
      key: index,
      class: ['breadcrumb-item', {
        active: true
      }]
    }, [_c('div', {
      staticClass: "breadcrumb-content"
    }, [item.iconClass === 'flexibility-icon' ? [_c('FlexibilityIcon', {
      staticClass: "icon breadcrumb-icon",
      staticStyle: {
        "height": "15px"
      }
    })] : [_c('span', {
      staticClass: "breadcrumb-icon",
      class: item.iconClass
    })], _c('span', {
      staticClass: "breadcrumb-title"
    }, [_vm._v(_vm._s(_vm.getTranslatedBreadcrumbText(item)))])], 2)]);
  })], 2), _c('b-breadcrumb', {
    staticClass: "desktop-breadcrumbs new-breadcrumbs"
  }, [_vm.itemsWithIcons.length > 3 ? _c('b-breadcrumb-item', {
    key: 'dropdown',
    staticClass: "breadcrumb-item"
  }, [_c('b-dropdown', {
    attrs: {
      "text": "...",
      "variant": "link",
      "no-caret": "",
      "menu-class": "dropdown-menu-dark"
    }
  }, _vm._l(_vm.itemsWithIcons.slice(0, -3), function (item, index) {
    return _c('b-dropdown-item', {
      key: index,
      staticClass: "dark-dropdown-item",
      attrs: {
        "href": item.path
      }
    }, [_c('div', {
      staticClass: "breadcrumb-content",
      on: {
        "click": function ($event) {
          return _vm.navigateTo(item, $event);
        }
      }
    }, [item.iconClass === 'flexibility-icon' ? [_c('FlexibilityIcon', {
      staticClass: "icon breadcrumb-icon",
      staticStyle: {
        "height": "15px"
      }
    })] : [_c('span', {
      staticClass: "breadcrumb-icon",
      class: item.iconClass
    })], _c('span', {
      staticClass: "breadcrumb-title"
    }, [_vm._v(_vm._s(_vm.getTranslatedBreadcrumbText(item)))])], 2)]);
  }), 1)], 1) : _vm._e(), _vm._l(_vm.itemsWithIcons.slice(-3), function (item, index) {
    return _c('b-breadcrumb-item', {
      key: index,
      class: ['breadcrumb-item', 'new-breadcrumb-item', {
        active: index === _vm.itemsWithIcons.length - 1
      }, {
        'non-clickable': item.doNotVisit
      }],
      attrs: {
        "href": item.path
      },
      on: {
        "click": function ($event) {
          return _vm.navigateTo(item, $event);
        }
      }
    }, [_c('div', {
      staticClass: "breadcrumb-content"
    }, [item.iconClass === 'flexibility-icon' ? [_c('FlexibilityIcon', {
      staticClass: "icon breadcrumb-icon",
      staticStyle: {
        "height": "15px"
      }
    })] : [_c('span', {
      staticClass: "breadcrumb-icon",
      class: item.iconClass
    })], _c('span', {
      staticClass: "breadcrumb-title"
    }, [_vm._v(_vm._s(_vm.getTranslatedBreadcrumbText(item)))])], 2)]);
  })], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }